// @flow
export const LOCATION_BELOW_THE_FOLD_CTA = 'Below-The-Fold CTA';
export const LOCATION_HERO_CTA = 'Hero CTA';
export const LOCATION_ORDER_FORM = 'Order Form';
export type TrackingLocation = typeof LOCATION_BELOW_THE_FOLD_CTA
| typeof LOCATION_HERO_CTA
| typeof LOCATION_ORDER_FORM;
